import React from 'react';
import { LazySellerPageMultiBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const MultiBanner = () => (
    <BannerWrapper>
        <LazySellerPageMultiBanner />
    </BannerWrapper>
);
